<!-- <div class="searchbar border-grey-1 bg-color-white" id="barra-pesquisa" aria-label="pesquisarEmCursos" role="searchbox"> -->

<div id="page-filter" class="row">
   <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
      <form
         *ngIf="formularioPesquisa"
         [formGroup]="formularioPesquisa"
         (ngSubmit)="onPesquisar()"
      >
         <div class="row">
            <fieldset class="col-xs-12">
               <div class="row">
                  <div
                     class="form-group"
                     [ngClass]="{
                        'col-xs-12 col-sm-12 col-md-6 col-lg-6': filtroArea,
                        'col-xs-12 col-sm-12 col-md-12 col-lg-12':
                           filtros && !filtroArea,
                        'col-xs-12 col-sm-12 col-md-9 col-lg-9':
                           !filtros && !filtroArea
                     }"
                  >
                     <div class="br-input">
                        <label for="input-default">{{ labelInput }}</label>
                        <input
                           title="Nome"
                           id="busca-{{ componenteAtual }}"
                           type="text"
                           name="StringBusca"
                           [value]="searchString"
                           formControlName="stringBusca"
                           aria-label="digiteoTextoDaSuaPesquisa"
                           placeholder="Filtrar por nome"
                           (click)="toggleDropdown('nome')"
                        />
                     </div>
                  </div>
                  <!-- <br /> -->

                  <!-- Àrea para eixos-->
                  <div
                     *ngIf="filtroArea"
                     class="form-group col-xs-12 col-sm-12 col-md-3 col-lg-3"
                  >
                     <ng-container
                        *ngTemplateOutlet="objAreaTecnologica"
                     ></ng-container>
                  </div>

                  <!-- Filtros para cursos-->
                  <div *ngIf="filtros">
                     <ng-container *ngTemplateOutlet="objfiltro"></ng-container>
                  </div>

                  <div
                     *ngIf="!filtros"
                     class="form-group buttons col-xs-12 col-sm-12 col-md-12 col-lg-3"
                  >
                     <ng-container
                        *ngTemplateOutlet="btofiltrar"
                     ></ng-container>
                  </div>
               </div>
               {{ mensagem }}
            </fieldset>

            <ng-template #objfiltro>
               <fieldset class="col-xs-12">
                  <div class="row">
                     <div
                        class="form-group col-xs-12 col-sm-6 col-md-3 col-lg-3"
                     >
                        <div class="br-select">
                           <div
                              class="br-input"
                              (click)="toggleDropdown('eixo')"
                           >
                              <label for="input-default"
                                 >Eixo Tecnológico</label
                              >
                              <input
                                 id="slcEixoTecnologico"
                                 Title="Eixo tecnológico"
                                 type="text"
                                 placeholder="Filtrar por eixo tecnológico"
                                 formControlName="eixo"
                                 readonly
                              />
                              <button
                                 class="br-button"
                                 type="button"
                                 aria-label="Exibir lista"
                                 data-trigger="data-trigger"
                                 tabindex="-1"
                              >
                                 <i
                                    class="fas fa-angle-down"
                                    aria-hidden="true"
                                 ></i>
                              </button>
                           </div>
                           <div
                              class="br-list"
                              tabindex="0"
                              [attr.expanded]="dropdownAbertoEixo ? '' : null"
                           >
                              <div
                                 class="br-item"
                                 tabindex="-1"
                                 *ngFor="let eixo of eixos"
                                 (click)="
                                    selecionarItem('eixo', eixo.nome, eixo.id)
                                 "
                              >
                                 <div class="br-radio">
                                    <input
                                       id="rbEixoTecnologico{{ eixo.id }}"
                                       type="radio"
                                       [value]="eixo.id"
                                       formControlName="eixo"
                                    />
                                    <label
                                       for="rbEixoTecnologico{{ eixo.id }}"
                                       >{{ eixo.nome }}</label
                                    >
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <!-- Àrea para filtro de cursos-->
                     <div
                        *ngIf="filtros"
                        class="form-group col-xs-12 col-sm-6 col-md-3 col-lg-2"
                     >
                        <ng-container
                           *ngTemplateOutlet="objAreaTecnologica"
                        ></ng-container>
                     </div>

                     <div
                        class="form-group col-xs-12 col-sm-6 col-md-3 col-lg-2"
                     >
                        <div class="br-select">
                           <div
                              class="br-input"
                              (click)="toggleDropdown('tipo')"
                           >
                              <label for="input-default">Tipo</label>
                              <input
                                 id="slcTipo"
                                 type="text"
                                 placeholder="Filtrar por tipo"
                                 formControlName="filtro"
                                 readonly
                              />
                              <button
                                 class="br-button"
                                 type="button"
                                 aria-label="Exibir lista"
                                 tabindex="-1"
                                 data-trigger="data-trigger"
                              >
                                 <i
                                    class="fas fa-angle-down"
                                    aria-hidden="true"
                                 ></i>
                              </button>
                           </div>
                           <div
                              class="br-list"
                              tabindex="0"
                              [attr.expanded]="dropdownAbertoTipo ? '' : null"
                           >
                              <div
                                 class="br-item"
                                 tabindex="-1"
                                 *ngFor="let tipo of filtrarPor"
                                 (click)="
                                    selecionarItem('tipo', tipo.nome, tipo.id)
                                 "
                              >
                                 <div class="br-radio">
                                    <input
                                       id="rbTipo{{ tipo.id }}"
                                       type="radio"
                                       name="filtro"
                                       [value]="tipo.id"
                                       formControlName="filtro"
                                    />
                                    <label for="rbTipo{{ tipo.id }}">{{
                                       tipo.nome
                                    }}</label>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div
                        class="form-group col-xs-12 col-sm-6 col-md-3 col-lg-2"
                     >
                        <div class="br-select">
                           <div
                              class="br-input"
                              (click)="toggleDropdown('ordenacao')"
                           >
                              <label for="input-default">Ordenar por</label>
                              <input
                                 id="slcOrdenar"
                                 type="text"
                                 placeholder="Ordenar por"
                                 formControlName="ordenacao"
                                 readonly
                              />
                              <button
                                 class="br-button"
                                 type="button"
                                 aria-label="Exibir lista"
                                 tabindex="-1"
                                 data-trigger="data-trigger"
                              >
                                 <i
                                    class="fas fa-angle-down"
                                    aria-hidden="true"
                                 ></i>
                              </button>
                           </div>
                           <div
                              class="br-list"
                              tabindex="0"
                              [attr.expanded]="dropdownAbertoOrder ? '' : null"
                           >
                              <div
                                 class="br-item"
                                 tabindex="-1"
                                 *ngFor="let order of ordenarPor"
                                 (click)="
                                    selecionarItem(
                                       'ordenacao',
                                       order.nome,
                                       order.id
                                    )
                                 "
                              >
                                 <div class="br-radio">
                                    <input
                                       title="Oredenação"
                                       id="rbOrdenar{{ order.id }}"
                                       type="radio"
                                       name="ordenacao"
                                       [value]="order.id"
                                       formControlName="ordenacao"
                                    />
                                    <label for="rbOrdenar{{ order.id }}">{{
                                       order.nome
                                    }}</label>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>

                     <div
                        *ngIf="filtros"
                        class="form-group buttons col-xs-12 col-sm-12 col-md-12 col-lg-3"
                     >
                        <ng-container
                           *ngTemplateOutlet="btofiltrar"
                        ></ng-container>
                     </div>
                  </div>
               </fieldset>
            </ng-template>

            <ng-template #btofiltrar>
               <button
                  class="br-button secondary dark-mode mr-3"
                  type="button"
                  (click)="limparFiltro()"
               >
                  Limpar
               </button>
               <button class="br-button primary dark-mode mr-3" type="submit">
                  Filtrar
               </button>
            </ng-template>

            <ng-template #objAreaTecnologica>
               <div class="br-select">
                  <div class="br-input" (click)="toggleDropdown('area')">
                     <label for="input-default">Área Tecnológica</label>
                     <input
                        title="Area Tecnológica"
                        id="slcAreaTecnologica"
                        type="text"
                        [placeholder]="
                           msgSemArea
                              ? 'Não possui áreas tecnológicas'
                              : 'Filtrar por área tecnológica'
                        "
                        name="areaTecnologica"
                        formControlName="areaTecnologica"
                        [disabled]="!mostrarArea"
                        readonly
                     />
                     <button
                        class="br-button"
                        type="button"
                        aria-label="Exibir lista"
                        tabindex="-1"
                        data-trigger="data-trigger"
                        [disabled]="!mostrarArea"
                     >
                        <i class="fas fa-angle-down" aria-hidden="true"></i>
                     </button>
                  </div>
                  <div
                     class="br-list"
                     tabindex="0"
                     [attr.expanded]="dropdownAbertoArea ? '' : null"
                  >
                     <div
                        class="br-item"
                        tabindex="-1"
                        *ngFor="let area of areasTecnologicas"
                        (click)="selecionarItem('area', area.nome, area.id)"
                     >
                        <div class="br-radio">
                           <input
                              title="Àrea Tecnológica"
                              id="rbAreaTecnologica{{ area.id }}"
                              type="radio"
                              name="areaTecnologica"
                              [value]="area.id"
                              formControlName="areaTecnologica"
                           />
                           <label for="rbAreaTecnologica{{ area.id }}">{{
                              area.nome
                           }}</label>
                        </div>
                     </div>
                  </div>
               </div>
            </ng-template>
         </div>
      </form>
   </div>
</div>
